// assets
import { LoginOutlined, ProfileOutlined } from '@ant-design/icons';

// icons
const icons = {
  LoginOutlined,
  ProfileOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'administration',
  title: 'Administrativo',
  type: 'group',
  children: [
    {
      id: 'manage_users',
      title: 'Gerenciar usuários',
      type: 'item',
      url: '/gerenciar-usuarios',
      icon: icons.LoginOutlined,
      target: false
    }
  ]
};

export default pages;
